import { Component, OnDestroy, OnInit } from '@angular/core';
import { TokenCache } from '../security/token-cache';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit, OnDestroy {

  isCPMUser: boolean = false;
  selectedIndex: number;
  private routerSubscription: Subscription;

  constructor(
    private tokenCache: TokenCache,
    private router: Router
  ) { }

  ngOnInit() {
    this.isCPMUser = this.tokenCache.checkForCPMUser();
    this.syncFromUrl(this.router.url);
    this.routerSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.syncFromUrl(event.urlAfterRedirects);
      });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  public onTabChange(event: MatTabChangeEvent): void {
    this.navigateToTab(event.index);
  }

  private getTabs(): string[] {
    const tabs = ['manual-collections', 'edited-collections'];
    if (this.isCPMUser) {
      tabs.push('annual-adjustments');
      tabs.push('revenue-reconciliation');
    }
    tabs.push('node-management');
    tabs.push('import-downtime');
    tabs.push('work-order-groups');
    return tabs;
  }

  private navigateToTab(index: number): void {
    const tabKey = this.getTabs()[index];
    if (!tabKey) {
      return;
    }

    const targetUrl = `/admin/${tabKey}`;
    if (this.router.url !== targetUrl) {
      this.router.navigateByUrl(targetUrl);
    }
  }

  private syncFromUrl(url: string): void {
    const tabs = this.getTabs();
    const tabMatch = tabs.find((tab) => url.includes(`/admin/${tab}`));
    const index = tabMatch ? tabs.indexOf(tabMatch) : 0;
    const normalizedKey = tabs[index];
    this.selectedIndex = index;

    const targetUrl = `/admin/${normalizedKey}`;
    if (!url.includes('/admin/') || !url.includes(targetUrl)) {
      this.router.navigateByUrl(targetUrl, { replaceUrl: true });
    }
  }
}
